import styled from "styled-components";

interface IWidget {
  right: number;
  bottom: number;
  zIndex: number;
};

export const StyledWidget = styled('div')<{ widget: IWidget }>(({ theme, widget }) => `
  position: absolute;
  right: ${widget?.right}px;
  bottom: ${widget?.bottom}px;
  z-index: ${widget?.zIndex};
  transition: all 0.2s;
  border-radius: 100%;
`);

export const StyledWidgetWrapper = styled('div')<{ zIndex: number }>(({ theme, zIndex }) => `
  display: flex;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  z-index: ${zIndex};
`);